import rollbar from 'shared-assets/src/errors/errors';
import kfetch from '@kareo/kfetch';
import {
  FEATURE_SET_PRODUCT_BILLING,
} from '@kareo/billing-system';

import {
  SSO_LOGIN_KEY
} from 'clinical-reporting-ui/constants/cqm';
import { DateTime } from 'luxon';
import TieredPricing from 'shared-assets/lib/sdk/tieredPricing';
import ContextualHelpService from 'shared-assets/lib/sdk/contextualHelpService';
import ContextualHelpUtil, {HELP_SOURCES} from 'shared-assets/lib/utils/contextualHelpUtil';
import getPracticeProperties, { getCompanyTypeName } from 'shared-assets/lib/sdk/practiceProperties';
import {fsIdentify,setFullStoryUser} from 'shared-assets/lib/sdk/fullstory';
import Wootric from 'shared-assets/lib/sdk/wootric-sdk';
import ForethoughtLoader, { AI_ASSISTANT_ENABLED_FT } from 'shared-assets/lib/sdk/forethought';
import {getUserRoleFlagsObject} from 'shared-assets/lib/utils/segmentationInfo';
import DegradedStateController from 'shared-assets/lib/utils/controllers/DegradedStateController';
import { Roles } from 'shared-assets/lib/sdk/authenticatedUser';
import platformFeatures from 'shared-assets/lib/sdk/platformFeatures';
import platformFeaturesV2 from 'shared-assets/lib/sdk/platformFeaturesV2';

const SSO_NAV_TOKEN = 'sso-token';
const SSO_NAV_DEFAULT_VALUE = 'no-token-cached';

const COMPANY_TYPE_DIRECT_PRACTICE = 1;
const COMPANY_TYPE_BILLING_COMPANY = 2;

const CLAIMS_EDIT_AUTHORIZATION = 27;
const VIEW_PAYMENTS_AUTHORIZATION = 115;

const REVIEW_APPLY_ACTIONS_CLAIMS_PERMISSION = 66;
const REVIEW_APPLY_ACTIONS_PATIENTS_PERMISSION = 72;

// Feature flag for PX package in platform features v2
const PX_PACKAGE_V2_FEATURE_FLAG = 'patient-experience-product-purchased';
// New customer in platform features v2
const NEW_CUSTOMER_V2_EDITION_TYPE = 'tebra1.5';
// Patient Intake V2
const INTAKES_V1_URL = '/patient-intake-admin-ui/#/intakes/';
const INTAKES_V2_URL = '/v2/#/intakes';
const INTAKES_V2_FT = 'dark-feature.patient-intake-v2'; 
const AI_ASSISTANT_PID = 'ai-assistant-pid'; 
const AI_ASSISTANT_STATE = 'ai-assistant-state'; 

(function () {
  angular
    .module('kareo.ui.shared.directives.chrome-header', [
      'kareo.featureSetAreas',
      'kareo.ui.shared.directives.feature-area',
      'kareo.ui.shared.directives.krome-menu',
      'kareo.ui.shared.directives.chrome-header.navigation2',
      'kareo.ui.shared.modules.api.user.k-user-service',
      'kareo.ui.shared.directives.messaging-dropdown',
      'kareo.ui.shared.directives.chrome-header.active-container',
      'kareo.ui.shared.modules.api.open-billing-tasks',
      'kareo.environment.config',
      'kareo.ui.shared.modules.authentication.k-roles',
      'kareo.ui.shared.modules.intercom',
      'kareo.ui.shared.modules.api.practice.k-practice-service',
      'kareo.ui.shared.modules.api.practice.authorization-service'
    ])
    .directive('chromeHeader', kromeDirective)
    .factory('ChromeHeaderUrlFor', () => {
      return {
        logout() {
          return '/signout';
        },
        calendar() {
          return '/dashboard-calendar-ui/#/calendar';
        },
        dashboard() {
          return '/dashboard-calendar-ui/#/dashboard';
        },
        ehrFacesheet(patientId) {
          return '/facesheet-ui/api/viewFacesheet/patient/' + patientId;
        },
        ehrDemographics(patientId) {
          return '/EhrWebApp/patients/viewDemographics/' + patientId;
        },
        ehrSupport() {
          return 'http://www.kareo.com/help/ehr';
        },
        kmbSupport() {
          return 'https://helpme.kareo.com/KMB';
        },
        settings() {
          return '/my_settings?redirect-refresh=true';
        },
        newSettings() {
          return '/admin-ui/#/myprofile/aboutme';
        },
        patientCreate() {
          return '/patient-mgmt-ui/';
        },
        admin() {
          return '/admin-ui/';
        },
      };
    })
    .controller('DegradedStateController', DegradedStateController);

  function kromeDirective() {
    return {
      restrict: 'EAC',
      template: require('./krome.pug')(),
      controller: kromeController,
      link() {},
    };
  }

  kromeController.$inject = [
    '$scope',
    '$location',
    '$q',
    'featureSetAreas',
    'recentCharts',
    'featureSet',
    'ChromeHeaderUrlFor',
    'practice',
    'authenticatedUser',
    'activeCustomerProducts',
    'kUserService',
    'openBillingTasksService',
    '$cookies',
    '$window',
    '$http',
    'ENVIRONMENT_NAME',
    'K_ROLES',
    'intercom',
    'kPracticeService',
    'authorizationService'
  ];
  function kromeController(
    $scope,
    $location,
    $q,
    featureSetAreas,
    recentCharts,
    featureSet,
    UrlFor,
    practice,
    authenticatedUser,
    activeCustomerProducts,
    kUserService,
    openBillingTasksService,
    $cookies,
    $window,
    $http,
    ENVIRONMENT_NAME,
    K_ROLES,
    intercom,
    kPracticeService,
    authorizationService,
    customerSummary
  ) {
    intercom.prepare();
    const surveyNPSInitializator = Wootric.getInitializator();

    $scope.helpSources = HELP_SOURCES;
    $scope.aiChatBotStarted = false;

    /**
     * Start Patient Pop link SSO logic
     */

    const env = ENVIRONMENT_NAME || 'devint';

    // Patient Pop has QA and STG environments but no DEV environment
    // Mapping PROD -> PROD and QA -> QA
    // Also mapping DEV -> QA so that we can test locally with Local Proxy connected to QA
    // When you run locally with Local Proxy connect to QA,
    // web-app connects to the QA back-end but localhost is interpreted as devint
    // The link will not work when deployed to the DEV environment
    const envKareoToPatientPop = {
      "prodlas":"https://app.patientpop.com/sso/redirect?token=",
      "prod":"https://app.patientpop.com/sso/redirect?token=",
      "test":"https://app.qa1.patientpop.com/sso/redirect?token=",
      "devint":"https://app.qa1.patientpop.com/sso/redirect?token="
    }
    
    $scope.patientPopSsoUrl = '';

    function loadPatientPopToken(){
      // store sso-token that expires every 15 minutes
      // caching the token on the front end saves calls to the service on every page load
      const ssoCookieValue = $cookies.get(SSO_NAV_TOKEN);
      if(!ssoCookieValue){
        $http.get('/common-ui/api/Sso/patientPopToken').then((response) => {
          const responseToken = response?.data?.token;
          if(responseToken){
            $scope.patientPopSsoUrl = `${envKareoToPatientPop[env]}${responseToken}&path=`;
            // set token to be cached for the duration of the sso-token lifetime
            $cookies.put(SSO_NAV_TOKEN, responseToken, { path:'/', expires: moment().add('15', 'minutes').toDate() });
          } else {
            // when a user doesn't have a token, cache that value so that every load
            // doesn't make an additional call which will most likely return no token
            $cookies.put(SSO_NAV_TOKEN, SSO_NAV_DEFAULT_VALUE, { path:'/', expires: moment().add('5', 'minutes').toDate() });
            $scope.patientPopSsoUrl = '';
          }
        }).catch(() => {
          $cookies.put(SSO_NAV_TOKEN, SSO_NAV_DEFAULT_VALUE, { path:'/', expires: moment().add('5', 'minutes').toDate() });
          $scope.patientPopSsoUrl = '';
        })
      } else {
        if(ssoCookieValue === SSO_NAV_DEFAULT_VALUE){
          // don't show the link if the cookie is the default value and not a token
          $scope.patientPopSsoUrl = '';
        } else {
          $scope.patientPopSsoUrl = `${envKareoToPatientPop[env]}${ssoCookieValue}&path=`;
        }
      }
    }
    // the SSO token is a 1 time usage, recreate the SSO token after each usage
    function patientPopLinkClicked () {
      // remove cookie to have new sso token created
      $cookies.remove(SSO_NAV_TOKEN);
      loadPatientPopToken();
    }

    $scope.patientPopLinkClicked = patientPopLinkClicked;

    /**
     * End Patient Pop link SSO logic
     */

    practice.get().then(setPractice);

    recentCharts.get().then(charts => {
      $scope.recentCharts = charts;
    });

    $scope.showSolutionCenter = false;
    $scope.showSupportCenter = false;
    
    async function getKareoPaymentSettings(ignoreCached = false) {
      return kfetch(
          '/payments-ui/api/PatientPayment/settings',
        )
    }

    getKareoPaymentSettings()
      .then(settings => {
        $scope.kareoPaymentSettings = settings;
      })
      .catch(error => {
        rollbar.error(error, 'Error fetching payment settings');
      });

    openBillingTasksService
      .getOpenBillingTasksSummary()
      .then(openBillingTasks => {
        $scope.openBillingTasks = openBillingTasks;
      });

    platformFeatures.getAllPlatformFeatures()
      .then(features => {
        $scope.platformFeatures = features;
      })
      .catch(error => {
        rollbar.error(error, 'Error fetching platform features');
      });

    $q.all([
      featureSetAreas.load(),
      activeCustomerProducts.get(),
      featureSet.load(),
      kPracticeService.getPracticeSelfPay(),
      authenticatedUser.get(),
      platformFeaturesV2.getAllPlatformFeaturesV2AndType(),
    ]).then(responses => {
      // load patient pop sso token on navigation load
      const [features, customerProduct, featureToggleResponse, selfPayPracticeResponse, userData, platformFeaturesV2AndType] = responses;
      setUser(userData);
      if (featureToggleResponse['dark-feature.patient-pop-sso-link']) {
        loadPatientPopToken();
      }
      return initFeatures(features, customerProduct, featureToggleResponse, selfPayPracticeResponse, platformFeaturesV2AndType);
    });

    async function initFeatures(features, customerProduct, featureToggles, selfPayPracticeResponse, platformFeaturesV2AndType) {
      $scope.isSelfPayPractice = selfPayPracticeResponse.value === 'true';
      $scope.features = features;
      $scope.isKmbCustomer = !!customerProduct.RCM;
      $scope.featureToggles = featureToggles;
      $scope.$cookies = $cookies;
      $scope.hasBillingModule = $scope.features[FEATURE_SET_PRODUCT_BILLING].enabled;
      $scope.customerHasPX = await platformFeaturesV2.isEnabled(PX_PACKAGE_V2_FEATURE_FLAG);
      $scope.isNewCustomer = platformFeaturesV2AndType.editionSetType === NEW_CUSTOMER_V2_EDITION_TYPE;
      $scope.newCustomerWithoutPX = $scope.isNewCustomer && !$scope.customerHasPX;
      $scope.hasV2IntakeFeatureToggle = featureToggles[INTAKES_V2_FT];
      $scope.hasReputationV2 = featureToggles['dark-feature.reputation-v2'];
    
      $scope.hasWorklistPermissions = featureToggles['dark-feature.enable-worklist-views'] &&
                                      featureToggles['dark-feature.missed-charges-worklist'] && (
                                      features['feature-set.area.charges'].show || (($scope.isSelfPayPractice || 
                                      featureToggles['dark-feature.show-charges-in-appointment']) && $scope.isOfficeStaff)) ||
                                      (featureToggles['dark-feature.analytics-global-nav-option'] &&
                                      featureToggles['dark-feature.enable-worklist-views'] && 
                                      featureToggles['dark-feature.missed-charges-worklist']);

      $scope.canUsePayouts = 
        featureToggles['dark-feature.tebra-payfac-payouts'] &&
        featureToggles['dark-feature.tebra-payment-facilitation'] &&
        ($scope.isAdmin || $scope.isBiller || $scope.isFinancialAnalyst);

      $scope.canUsePatientCollections = 
        featureToggles['dark-feature.patient-collections-worklist'] &&
        ($scope.isAdmin || $scope.isBiller || $scope.isFinancialAnalyst);

      $scope.canUsePracticePerformance =
        featureToggles['dark-feature.multipractice-dashboard'] &&
        ($scope.isAdmin || $scope.isBiller || $scope.isFinancialAnalyst);
                                                            
      if (
        $scope.isKmbCustomer &&
        !$scope.features['feature-set.area.billing-tasks'].enabled
      ) {
        isLoggedInUserRcmEmployee();
      }
      var relaxedPlatform =
        !!featureToggles['dark-feature.billing-tasks-relaxed-platform-perm'];
      var billingTaskEnabled =
        features['feature-set.area.billing-tasks'].show ||
        $scope.isRcmEmployee ||
        ($scope.isKmbCustomer && relaxedPlatform);
      var afterRCMGoLive = false;
      if (customerProduct.RCM && customerProduct.RCM.activationDate) {
        // GoLive Date = activation date + 90 days. Here 90days  == 7776000000 milliseconds.
        var goLive = new Date(customerProduct.RCM.activationDate + 7776000000);
        // set the goLive date to 00:00:00 Military time
        goLive.setHours(0, 0, 0, 0);

        afterRCMGoLive = new Date().getTime() > goLive.getTime();
      }
      // show the card when billingTaskEnabled and uxEnhancement toggle 'on' and Current Date > RCMGoLive date
      $scope.showBillingTasksAssigned =
        billingTaskEnabled &&
        featureToggles['dark-feature.billing-tasks-ux-enhancements'] &&
        afterRCMGoLive;

      $scope.showOpenNotes = function() {
        return (
          features['feature-set.area.notes'].show &&
          (featureToggles['dark-feature.complete-non-clinical-note'] ||
            authenticatedUser.hasRole(Roles.Provider) ||
            authenticatedUser.hasRole(Roles.ClinicalAssistant))
        );
      };

      $scope.showPatientIntake = function() {
        return (
          featureToggles['dark-feature.patient-intake-mvp'] &&
          ($scope.isProvider || $scope.isAdmin || $scope.isOfficeStaff)
        );
      };

      let todaysDateAsParam = DateTime.local().toFormat('yyyy-MM-dd');

      function getDashboardUrl() {
        if (featureToggles['dark-feature.web-app-v2-scheduling']) {
          return `/v2/#/scheduling/dashboard/day/${todaysDateAsParam}`;
        }
        return `/dashboard-ui/`;
      }

      function getCalendarUrl() {
        if (featureToggles['dark-feature.convergence-calendar-upgrade']) {
          if (featureToggles['dark-feature.web-app-v2-scheduling']) {
            return `/v2/#/scheduling/calendar`
          }
          return `/dashboard-ui/#/?view=day`;
        }
        return '/dashboard-calendar-ui/#/calendar';
      }

      // Initialize the calendar and dashboard urls
      $scope.calendarUrl = getCalendarUrl();
      $scope.dashboardUrl = getDashboardUrl();

      function setDashboardAndCalendarUrl(newUrl) {
        const dateFromUrl = newUrl.split("/").pop();
        // Define a regular expression for the date format yyyy-MM-dd
        const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
        // Check if dateFromUrl matches the format
        const isValidDate = dateFormatRegex.test(dateFromUrl);

        // If the date is the same, do not update the urls
        const currDate = $scope.calendarUrl.split("/").pop();
        if ((dateFromUrl === currDate) || (!isValidDate && currDate === todaysDateAsParam)) {
          return;
        }

        // If the date is not valid, use the current date
        let dateParam = todaysDateAsParam;
        if (isValidDate) {
          dateParam = dateFromUrl;
        } 
        $scope.calendarUrl = `/v2/#/scheduling/calendar`;
        $scope.dashboardUrl = `/v2/#/scheduling/dashboard/day/${dateParam}`;
      }

      loadContextualHelp();
      setSupportURL();

      $scope.$on('$locationChangeSuccess', function(_, newUrl) { 
        setSupportURL();

        if (featureToggles['dark-feature.convergence-calendar-upgrade'] && featureToggles['dark-feature.web-app-v2-scheduling']) {
          setDashboardAndCalendarUrl(newUrl);
        }
      });

      function isPaymentsConfigured() {
        return (
          $scope.kareoPaymentSettings?.hasPaymentAccount &&
          $scope.kareoPaymentSettings?.registered
        );
      }
      function isPaymentsEnabled() {
        return $scope.kareoPaymentSettings?.enabled;
      }
      function isTebraPayfacActive() {
        return featureToggles['dark-feature.tebra-payment-facilitation'];
      }
      $scope.isTebraPayfacActive = isTebraPayfacActive;

      function isStripeActive() {
        return (
          isPaymentsConfigured() &&
          isPaymentsEnabled() &&
          !!$scope.kareoPaymentSettings?.stripeKeys?.kareoApiKey && 
          !!$scope.kareoPaymentSettings?.stripeKeys?.practiceApiKey
        );
      }
      $scope.isStripeActive = isStripeActive;

      $scope.openTebraPayments = function () {
        sessionStorage.setItem(
          'tebraPaymentsTopOfFunnel',
          'Global Navigation Menu',
        );
        $window.location.href = "/v2/#/payments-onboarding";
      }
      
      $scope.isTebraPaymentsItemShown = function () {
        return (
          !isStripeActive() &&
          !isTebraPayfacActive() &&
          featureToggles['dark-feature.tebra-payfac-settings-and-links'] &&
          featureToggles['dark-feature.tebra-payments-menu-item']
        );
      }

      $scope.showSupportCenter = !!featureToggles['dark-feature.support-center'];
      loadReportMenuVisibility();

      if(!!featureToggles[AI_ASSISTANT_ENABLED_FT]){
        checkAIAssistantState();
      }
    }

    function checkAIAssistantState() {
      const aiAssistantState = sessionStorage.getItem(AI_ASSISTANT_STATE);
      const aiAssistantPid = sessionStorage.getItem(AI_ASSISTANT_PID);
      if (!!aiAssistantState && !!aiAssistantPid) {
        startAIAssistant();
      }
    }

    function isChatBotExceptionPage() {
      return $window.location.hash?.includes('chart-navbar')
        || $window.location.hash?.includes('message-center/messages/guid');
    }

    function getPersistenceId(action) {
      const aiAssistantState = sessionStorage.getItem(AI_ASSISTANT_PID);
      if (!!aiAssistantState) {
        return aiAssistantState;
      }
      const persistenceId = action +'-'+ $scope.customerId +'-'+ $scope.userGuid +'-'+ new Date().getTime();
      sessionStorage.setItem(AI_ASSISTANT_PID, persistenceId);
      return persistenceId;
    }

    function startAIAssistant(action) {
      if(!!$scope.featureToggles[AI_ASSISTANT_ENABLED_FT] &&
        !$scope.aiChatBotStarted &&
        !isChatBotExceptionPage()
      ) {
        const persistanceId = getPersistenceId(action);
        initForethoughtChatBot(persistanceId);
      } else if($scope.aiChatBotStarted && !window.ForethoughtSettings?.visible) {
        // show chatbot
        ForethoughtLoader.toggleVisibility();
        sessionStorage.setItem(AI_ASSISTANT_STATE, 'true');
      }
    }

    function onAIChatBotClose() {
      sessionStorage.removeItem(AI_ASSISTANT_STATE);
    }

    async function initForethoughtChatBot(persistanceId) {
      // set this flag early before page reloads
      sessionStorage.setItem(AI_ASSISTANT_STATE, 'true');
      const initData = await ForethoughtLoader.getInitData();
      if(initData.customerId && initData.practiceGuid && initData.userGuid) {
        ForethoughtLoader.loadScript(persistanceId, initData, onAIChatBotClose).then(response => {
          $scope.aiChatBotStarted = !!response;
        });
      }
    }

    $scope.getFeatureClass = function(platformFeatureKey) {
      // Handle case where api is down; default to enabled
      if (!$scope.platformFeatures) return {};
      return {
        'is-disabled': !$scope.platformFeatures[platformFeatureKey]
      };
    }

    $scope.getIntakeFeatureHref = function(platformFeatureKey, defaultUrl) {
      // Handle case where api is down; default to enabled
      if (!$scope.platformFeatures) return defaultUrl;
     
      if ($scope.platformFeatures[platformFeatureKey] && $scope.hasV2IntakeFeatureToggle && defaultUrl === INTAKES_V1_URL) {
        return INTAKES_V2_URL;
      }

      return $scope.platformFeatures[platformFeatureKey] ? defaultUrl : undefined;
    };

    $scope.getPatientUrl = function(patientId) {
      if (featureSet.hasClinicalFeatures()) {
        return '/facesheet-ui/api/viewFacesheet/patient/' + patientId;
      }
      return '/EhrWebApp/patients/viewDemographics/' + patientId;
    };

    function setPractice(practiceData) {
      $scope.practiceName = practiceData.name;
      $scope.practiceGuid = practiceData.practiceGuid;
      $scope.customerId = practiceData.customerId;
      TieredPricing.isTieredPricing(practiceData.editionSetId).then(isTieredPricing => {
        // We are going to show the Solution Center if the custumer is not using Tiered Pricing
        $scope.showSolutionCenter = !isTieredPricing;
      });
      Wootric.initializedIfNPSEnabled(() => {
        surveyNPSInitializator.next({
          createdAt: practiceData.createdDate,
          practiceId: practiceData.practiceId,
          customerId: practiceData.customerId});
      });
      setFullStoryUser({
        pmEnabled: practiceData?.pmenabled,
        practiceGuid: practiceData?.practiceGuid
      });
    }

    function setUser(userData) {
      $scope.isProvider = authenticatedUser.hasRole(Roles.Provider);
      $scope.isAdmin = authenticatedUser.hasRole(Roles.SystemAdministrator);
      $scope.isBiller = authenticatedUser.hasRole(Roles.Biller);
      $scope.isOfficeStaff = authenticatedUser.hasRole(Roles.OfficeStaff);
      $scope.isFinancialAnalyst = authenticatedUser.hasRole(Roles.FinancialAnalyst); // should also mean Business Manager
      $scope.isClinicalAssistant = authenticatedUser.hasRole(Roles.ClinicalAssistant);
      $scope.userFullName = userData.fullName();
      $scope.userGuid = userData.userGuid;
      // Add data to the fullstory session about the user
      fsIdentify(userData.userId);
      getAvatarImage(userData?.userGuid);

      let trackingInfo = {
        userType: userData?.roles.some( role => role.id === K_ROLES.PROVIDER) ? 'Provider' : 'Non-Provider',
        email: userData?.email,
      };
      setFullStoryUser({
        displayName: userData.fullName(),
        ...trackingInfo,
        userId: userData?.pmUserId,
        ... getUserRoleFlagsObject(K_ROLES, userData?.roles),
      });
      Wootric.initializedIfNPSEnabled(() => {
        surveyNPSInitializator.next({
          ...trackingInfo,
          roles: userData?.roles.map( role => role.name)
      });
    });
    }

    async function getAvatarImage(userGuid) {

      let imageUrl = getDefaultImageUrl();
      if(!userGuid) {
        $scope.userImageUrl = imageUrl;
        return;
      }

      const profileImageUrl = `/common-ui/api/User/profileImage/${userGuid}`;

      // Check that reaching the image endpoint is successful, but do not actually need to download image. It would be preferable to have the image's onError function handle this, but I have not been able to get that to work.
      $http.head(profileImageUrl)
        .then(response => {
          if (response.status === 200) {
            imageUrl = profileImageUrl;
          } 
        })
        .catch(error => {
          if(error.status !== 401) {
            rollbar.error(error, "Error fetching user image url");
          }
        }).finally(()=> {
          $scope.userImageUrl = imageUrl;
        })
    }

    function getDefaultImageUrl() {
      const isProvider = authenticatedUser.hasRole(Roles.Provider);
      if(isProvider) {
        return '/shared-assets-ui/bundle/css/img/chrome/persona/provider-tebra-bg.svg'
      } else {
        return '/shared-assets-ui/bundle/css/img/chrome/persona/staff-tebra-bg.svg'
      }
    }

    function isLoggedInUserRcmEmployee() {
      kUserService.isRcmEmployee().then(
        response => {
          $scope.isRcmEmployee = response;
        },
        failure => {}
      );
    }

    $scope.logOutCqm = async function() {
      // Reset dashboard tab for next login
      localStorage.setItem('last-selected-tab-nav', 'SCHEDULED');
      // Close AI chatbot
      if(!!$scope.featureToggles[AI_ASSISTANT_ENABLED_FT]){
        sessionStorage.removeItem(AI_ASSISTANT_STATE);
      }
      // Indicate to Fullstory that the seession has ended
      if (sessionStorage.getItem(SSO_LOGIN_KEY)) {
        sessionStorage.removeItem(SSO_LOGIN_KEY);
        try {
          await kUserService.logOutFromCqmSolution();
          $window.location.href = '/signout';
        } catch(error) {
          rollbar.error('Error logging out from CQMsolution', error);
          $window.location.href = '/signout';
        }
      } else {
        $window.location.href = '/signout';
      }
    };

    $scope.clickHelp = function(event, source) {
      // We need to track the current url and article related
      ContextualHelpUtil.trackHelpClick(
        {
          article: event?.target?.href ? event.target.href : $scope.supportURL,
          path: $window.location.href,
          source,
        }, 
        $window.location.hostname
      );
      startAIAssistant('help');
    };

    $scope.clickCustomerCare = function() {
      startAIAssistant('customer care');
    };

    function loadContextualHelp() {      
      const mindTouchScripts = ContextualHelpUtil.getMindTouchScripts($window.location.hostname);
      if(mindTouchScripts){
        document.querySelector('.chrome-wrapper.krome-container.normal').appendChild(mindTouchScripts.node1);
        document.querySelector('.chrome-wrapper.krome-container.normal').appendChild(mindTouchScripts.node2);
      }
    };

    function setSupportURL(){    
      ContextualHelpService.getContextualHelpConfiguration().then(contextualHelpConfig => {
        $scope.supportURL = ContextualHelpUtil.getContextualHelpSpecificArticle($window.location, contextualHelpConfig);
      });
    }

    getPracticeProperties().then( properties => {
      let trackingInfo = {
        customerId: properties?.customerId,
        practiceId: properties?.practiceId,
        practiceSpecialty: properties?.practiceSpecialty,
        pricingFamily: properties?.editionType?.caption,
        companyType: getCompanyTypeName(properties?.companyType),
        isPatientPopPartnerActive: properties?.isPatientPopPartnerActive
      };
      Wootric.initializedIfNPSEnabled(() => surveyNPSInitializator.next(trackingInfo));
      setFullStoryUser({...trackingInfo, isJointCustomer: trackingInfo?.isPatientPopPartnerActive});
    });

    function loadReportMenuVisibility () {
      Promise.all([
        authorizationService.getUserIsAuthorized({ pmPermissionIds: [VIEW_PAYMENTS_AUTHORIZATION] }),
        authorizationService.getUserIsAuthorized({ pmPermissionIds: [CLAIMS_EDIT_AUTHORIZATION] }),
        authorizationService.getUserPermissions(),
        getPracticeProperties()
      ]).then(([
        isAuthorizedViewPatientPayments, 
        isAuthorizedClaimsEdit, 
        userPermissions, 
        practiceProperties
      ]) => {
        const companyType = practiceProperties?.companyType;

        const permissions = !!userPermissions?.data?.permissions?.length ? userPermissions?.data?.permissions : [];
        const hasReviewApplyActionClaims = permissions.some(permission => permission.permissionId === REVIEW_APPLY_ACTIONS_CLAIMS_PERMISSION);
        const hasReviewApplyActionPatients = permissions.some(permission => permission.permissionId === REVIEW_APPLY_ACTIONS_PATIENTS_PERMISSION);

        const billingCompanyAndClaimsEdit = companyType === COMPANY_TYPE_BILLING_COMPANY && isAuthorizedClaimsEdit;
        const directPracticeAndApplyActionsClaims = companyType === COMPANY_TYPE_DIRECT_PRACTICE && hasReviewApplyActionClaims;
        const hasInsuranceCollectionsWorklistFT = $scope.featureToggles['dark-feature.insurance-collections-worklist']; 
        const hasPatientsWorklistFT = $scope.featureToggles['dark-feature.patients-worklist']; 
        const hasARDashboardFT = $scope.featureToggles['dark-feature.accounts-receivable-dashboard'];

        $scope.$apply(() => {
          $scope.isAuthorizedViewPatientPayments = isAuthorizedViewPatientPayments;
          $scope.isClaimsSubmenuVisible = hasInsuranceCollectionsWorklistFT 
                && (billingCompanyAndClaimsEdit || directPracticeAndApplyActionsClaims);
          $scope.isPatientsSubmenuVisible = hasPatientsWorklistFT && hasReviewApplyActionPatients;
          $scope.isARDashboardVisible = hasARDashboardFT 
                && (billingCompanyAndClaimsEdit || directPracticeAndApplyActionsClaims);
        })

      });
    }
    
  }
})();
